export const question = {
  update: "Confirmar aleração?",
  delete: "Confirmar exclusão?",

  openSchedule:
    "Já existe uma OS aberta para esta localidade. Deseja Continuar? ",
};
